import {Dimensions, NativeModules, Platform} from 'react-native';

// 3D-Secure 2.0 requires "device data", but at least one of the required
// fields is typically available in web browsers and not on mobile devices:
// color_depth. On mobile, we use a WebView for this (and being there, for
// the rest of the fields too). The actual JS executed in the WebView comes
// from the backend for easier updates.
// Refs:
// - MFL API docs: Shop / Orders / Checkout - Checks out the order.
//   https://dev.azure.com/lmgdevops/branded_website/_wiki/wikis/branded_website.wiki/29/3rd-party-APIs
// - https://gateway.tillpayments.com/documentation/apiv3#transaction-data-3d-secure-2-0-device-data
export const mobileWebView3DsBrowserDataHtml = '<!DOCTYPE html><html><body></body></html>';

export interface BrowserData {
  java_enabled: boolean;
  language: string;
  color_depth: number;
  screen_height: number;
  screen_width: number;
  timezone: number;
}

export function getWeb3DsBrowserData(): BrowserData {
  return {
    java_enabled:
      typeof window.navigator.javaEnabled === 'function' ? window.navigator.javaEnabled() : false,
    language: window.navigator?.language ?? 'en-AU',
    color_depth: window.screen?.colorDepth ?? 24,
    screen_height: window.screen?.height ?? 0,
    screen_width: window.screen?.width ?? 0,
    timezone: new Date().getTimezoneOffset(),
  };
}

/**
 * Get browser-like data for native iOS/Android apps.
 * Required by Till Payments for all transaction types including Apple Pay.
 * Uses device info since there's no actual browser.
 */
export function getNativeBrowserData(): BrowserData {
  const {height, width} = Dimensions.get('screen');

  // Get device locale
  let language = 'en-AU';
  if (Platform.OS === 'ios') {
    const locale =
      NativeModules.SettingsManager?.settings?.AppleLocale ||
      NativeModules.SettingsManager?.settings?.AppleLanguages?.[0];
    if (locale) {
      language = locale.replace('_', '-');
    }
  } else if (Platform.OS === 'android') {
    const locale = NativeModules.I18nManager?.localeIdentifier;
    if (locale) {
      language = locale.replace('_', '-');
    }
  }

  return {
    java_enabled: false, // Native apps don't have Java
    language,
    color_depth: 24, // Modern mobile screens are 24-bit
    screen_height: Math.round(height),
    screen_width: Math.round(width),
    timezone: new Date().getTimezoneOffset(),
  };
}
